'use client';

import Link from 'next/link';

export default function ImpressumPage() {
  return (
    <div style={{ minHeight: '100vh', background: '#0a0f1e', color: '#e2e8f0', fontFamily: "'Inter', sans-serif" }}>
      {/* Header */}
      <div style={{ borderBottom: '1px solid rgba(255,255,255,0.08)', padding: '20px 0' }}>
        <div style={{ maxWidth: 800, margin: '0 auto', padding: '0 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Link href="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ fontFamily: "'Schibsted Grotesk', sans-serif", fontWeight: 800, fontSize: 22, color: '#fff' }}>
              Done<span style={{ color: '#F26522' }}>2</span>Go
            </span>
          </Link>
          <Link href="/" style={{ fontSize: 14, color: 'rgba(255,255,255,0.5)', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 6 }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
            Zurück zur Startseite
          </Link>
        </div>
      </div>

      {/* Content */}
      <div style={{ maxWidth: 800, margin: '0 auto', padding: '60px 24px 80px' }}>
        <h1 style={{ fontFamily: "'Schibsted Grotesk', sans-serif", fontSize: 36, fontWeight: 800, color: '#fff', marginBottom: 8 }}>Impressum</h1>
        <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.4)', marginBottom: 48 }}>Angaben gemäß § 5 TMG</p>

        <section style={{ marginBottom: 40 }}>
          <h2 style={{ fontFamily: "'Schibsted Grotesk', sans-serif", fontSize: 20, fontWeight: 700, color: '#F26522', marginBottom: 16 }}>Anbieter</h2>
          <p style={{ lineHeight: 1.8, color: 'rgba(255,255,255,0.75)' }}>
            Done2Go<br />
            Digitale Lösungen für Mikro-Unternehmen<br />
            [Straße und Hausnummer]<br />
            [PLZ Ort], Deutschland
          </p>
        </section>

        <section style={{ marginBottom: 40 }}>
          <h2 style={{ fontFamily: "'Schibsted Grotesk', sans-serif", fontSize: 20, fontWeight: 700, color: '#F26522', marginBottom: 16 }}>Kontakt</h2>
          <p style={{ lineHeight: 1.8, color: 'rgba(255,255,255,0.75)' }}>
            E-Mail: <a href="mailto:info@done2go.com" style={{ color: '#F26522', textDecoration: 'none' }}>info@done2go.com</a><br />
            Telefon: [Ihre Telefonnummer]
          </p>
        </section>

        <section style={{ marginBottom: 40 }}>
          <h2 style={{ fontFamily: "'Schibsted Grotesk', sans-serif", fontSize: 20, fontWeight: 700, color: '#F26522', marginBottom: 16 }}>Umsatzsteuer-ID</h2>
          <p style={{ lineHeight: 1.8, color: 'rgba(255,255,255,0.75)' }}>
            Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:<br />
            [Ihre USt-IdNr.]
          </p>
        </section>

        <section style={{ marginBottom: 40 }}>
          <h2 style={{ fontFamily: "'Schibsted Grotesk', sans-serif", fontSize: 20, fontWeight: 700, color: '#F26522', marginBottom: 16 }}>Verantwortlich für den Inhalt</h2>
          <p style={{ lineHeight: 1.8, color: 'rgba(255,255,255,0.75)' }}>
            [Vorname Nachname]<br />
            [Straße und Hausnummer]<br />
            [PLZ Ort]
          </p>
        </section>

        <section style={{ marginBottom: 40 }}>
          <h2 style={{ fontFamily: "'Schibsted Grotesk', sans-serif", fontSize: 20, fontWeight: 700, color: '#F26522', marginBottom: 16 }}>Streitschlichtung</h2>
          <p style={{ lineHeight: 1.8, color: 'rgba(255,255,255,0.75)' }}>
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
            <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" style={{ color: '#F26522', textDecoration: 'none' }}>
              https://ec.europa.eu/consumers/odr/
            </a>.<br /><br />
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
          </p>
        </section>

        <section style={{ marginBottom: 40 }}>
          <h2 style={{ fontFamily: "'Schibsted Grotesk', sans-serif", fontSize: 20, fontWeight: 700, color: '#F26522', marginBottom: 16 }}>Haftung für Inhalte</h2>
          <p style={{ lineHeight: 1.8, color: 'rgba(255,255,255,0.75)' }}>
            Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
          </p>
        </section>

        <section style={{ marginBottom: 40 }}>
          <h2 style={{ fontFamily: "'Schibsted Grotesk', sans-serif", fontSize: 20, fontWeight: 700, color: '#F26522', marginBottom: 16 }}>Urheberrecht</h2>
          <p style={{ lineHeight: 1.8, color: 'rgba(255,255,255,0.75)' }}>
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
          </p>
        </section>

        {/* Footer links */}
        <div style={{ borderTop: '1px solid rgba(255,255,255,0.08)', paddingTop: 32, marginTop: 48, display: 'flex', gap: 24, flexWrap: 'wrap' }}>
          <Link href="/impressum" style={{ fontSize: 13, color: '#F26522', textDecoration: 'none' }}>Impressum</Link>
          <Link href="/datenschutz" style={{ fontSize: 13, color: 'rgba(255,255,255,0.4)', textDecoration: 'none' }}>Datenschutz</Link>
          <Link href="/agb" style={{ fontSize: 13, color: 'rgba(255,255,255,0.4)', textDecoration: 'none' }}>AGB</Link>
        </div>
      </div>
    </div>
  );
}
